import { CloudUpload } from "@mui/icons-material";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import {
  IStyledAttributes,
  MuiPaletteType,
  MuiSize,
  MuiVariant,
} from "@ryde/shared";

import { MuiButton } from "./button";

interface IMuiUploadButton {
  muiStyle?: MuiPaletteType;
  muiSize?: MuiSize;
  muiVariant?: MuiVariant;
  disabled?: boolean;
  loading?: boolean;
  accept?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const MuiUploadInputStyled = styled.input.attrs<IStyledAttributes>({
  "data-e2e": "upload-button-content",
})`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  inset-inline-end: 0;
  inset-inline-start: 0;
  white-space: nowrap;
  width: 1px;
`;

export const MuiUploadButton: FC<IMuiUploadButton> = ({
  muiStyle,
  muiSize,
  muiVariant,
  disabled,
  loading,
  accept,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <MuiButton
      component="label"
      muiStyle={muiStyle}
      muiSize={muiSize}
      muiVariant={muiVariant}
      startIcon={<CloudUpload />}
      disabled={disabled}
      loading={loading}
    >
      {t("general.UPLOAD_FILE")}
      <MuiUploadInputStyled type="file" accept={accept} onChange={onChange} />
    </MuiButton>
  );
};
